"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const hasAttr_1 = require("./hasAttr");
exports.isRepeaterBlock = (childEl, parentBlock) => {
    if (parentBlock &&
        parentBlock.type === 'repeater' &&
        !hasAttr_1.hasAttr(childEl, 'repeat')) {
        return false;
    }
    return true;
};
//# sourceMappingURL=isRepeaterBlock.js.map